import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import line from "../Assets/Rectangle 40191.svg";
import gift from "../Assets/image 134.svg";
import video from "../Assets/image 82.svg";
import arrow from "../Assets/Back.svg";

function CorporateAllProducts() {
  return (
    <div className="homepage">
      <Navbar />
      <br />
      <div className="festival-section">
        <div className="festival">
          <h3>
            <span>Home </span> Festival{" "}
          </h3>
          <br />
          <h1>Festival</h1>
        </div>
      </div>
      <br /> <br />
      <div className="trendingOffer-section-heading">
        <img src={line} alt="Section divider" />
        <h1>Corporate Diwali Gifts</h1>
      </div>
      <br />
      <br />
      <div className="festival-gift-section">
        <div className="festival-gift"></div>
        <div className="giftproducts-section">
          <div className="giftproducts">
            <div className="giftproducts-card">
              <img src={gift} alt="Corporate gift hamper" />
              <h2>Blissful Celebration Diwali Hamper</h2>
            </div>
            <div className="giftproducts-card">
              <img src={gift} alt="Corporate gift hamper" />
              <h2>Blissful Celebration Diwali Hamper</h2>
            </div>
            <div className="giftproducts-card">
              <img src={gift} alt="Corporate gift hamper" />
              <h2>Blissful Celebration Diwali Hamper</h2>
            </div>
            <div className="giftproducts-card">
              <img src={gift} alt="Corporate gift hamper" />
              <h2>Blissful Celebration Diwali Hamper</h2>
            </div>
            <div className="giftproducts-card">
              <img src={gift} alt="Corporate gift hamper" />
              <h2>Blissful Celebration Diwali Hamper</h2>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="btn">
        <button className="abcd">
          Login to View Price <img className="logarrow" src={arrow} alt="Arrow icon" />
        </button>
      </div>
      <br />
      <br />
      <div className="video-section">
        <div className="video">
          <div className="trendingOffer-section-heading">
            <img src={line} alt="Section divider" />
            <h1>A Step By Step Guide To Make Your Digital Plan</h1>
          </div>
          <br />
          <br />

          <img className="vdio" src={video} alt="Digital guide placeholder" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CorporateAllProducts;
